import React from "react";
import { useLocation, useNavigate } from "react-router";

interface ContinueRedirectProps {
  fail: string;
}

export default function ContinueTo(props: ContinueRedirectProps) {
  const { fail } = props;

  const currentRoute = useLocation();

  const params = React.useMemo(
    () => new URLSearchParams(currentRoute.search),
    [currentRoute.search]
  );

  const redirectPath = params.get("continue") ?? fail;
  const navigate = useNavigate();

  React.useEffect(() => {
    navigate(redirectPath);
  }, [navigate, redirectPath]);

  return null;
}
